
export default class ProjectImage {
  id?: number;
  url?: string;
  encoded?: string;
  ext?: string;
  name?: string;

  constructor(entity: ProjectImage) {
    this.id = entity.id;
    this.url = entity.url;
    this.encoded = entity.encoded;
    this.ext = entity.ext;
    this.name = entity.name;
  }
}



// WEBPACK FOOTER //
// ./src/entities/ProjectImage.tsx